import React from 'react';
import PhoneInput, {
  formatPhoneNumberIntl,
} from 'react-phone-number-input/mobile';
import 'react-phone-number-input/style.css';
import { useFormikContext } from 'formik';
import '@/utils/addPhoneNumberValidator';
import { Input } from '@/components/ui/input';
import { cn } from '@/utils/utils';

type PhoneInputFieldProps = React.ComponentProps<typeof PhoneInput> & {
  name: string;
  onPhoneChange?: (phone: string) => void;
};

export const PhoneInputField: React.FC<PhoneInputFieldProps> = (props) => {
  const {
    className = '',
    name,
    defaultCountry = 'AR',
    onPhoneChange,
    disabled,
  } = props;

  const { setFieldValue, getFieldProps, getFieldMeta, getFieldHelpers } =
    useFormikContext();
  const { onBlur } = getFieldProps(name);
  const { setTouched } = getFieldHelpers(name);
  const { error, touched, value } = getFieldMeta(name);

  const isError = touched && error;

  const onValueChange = (phoneNumber: string | undefined) => {
    const intlNumber = !!phoneNumber && formatPhoneNumberIntl(phoneNumber);
    setFieldValue(name, intlNumber || phoneNumber || '');
    setTouched(true, true);
    onPhoneChange?.(intlNumber || phoneNumber || '');
  };

  return (
    <div className={cn(className, { 'peer invalid': isError })}>
      <PhoneInput
        placeholder="Ingresa un número de teléfono"
        international
        countryCallingCodeEditable={false}
        name={name}
        value={value as string}
        onChange={onValueChange}
        defaultCountry={defaultCountry}
        onBlur={onBlur}
        disabled={disabled}
        inputComponent={Input as any}
        autoComplete="off"
      />
    </div>
  );
};
